import { LOAD_LISTADO, StateListadoCarga } from "../../types/ranking/cargaTypes";

export const loadCargaListado = (data: StateListadoCarga) => ({ type: LOAD_LISTADO, payload: data });
